import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/one/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/one/SupportProgramPage"

const support_program = () => (
  <Layout>
    <SEO title={PAGE.title.support_program} siteTitle="one" />
    <HeadingL title={PAGE.title.support_program} target="one" />
    <AssessmentPage />
  </Layout>
)

export default support_program;
